import {
    matchingBatchRegulationsReceived,
    toggleFetchRegulationSelection
} from "./../../actions/regulation/EditBatchSelection/index";
import { createReducer } from "@reduxjs/toolkit";
import { toggleFetchRegulationPanel } from "../../actions/regulation/EditBatchSelection/index";
import { EditBatchSelectionState } from "../../actions/regulation/EditBatchSelection/types";
import { toggleEditBatchSelection } from "../../actions/regulation/EditBatchSelection";

const initialState: EditBatchSelectionState = {
    isEditBatchSelectionEnabled: false,
    isFetchRegulationPanelOpen: false,
    matchingBatchRegulations: [],
    isFetchRegulationSelection: false
};

const editBatchSelection = createReducer(initialState, (builder) => {
    builder
        .addCase(toggleEditBatchSelection, (state, action) => {
            state.isEditBatchSelectionEnabled = action.payload.isEditBatchSelectionEnabled;
        })
        .addCase(toggleFetchRegulationSelection, (state, action) => {
            state.isFetchRegulationSelection = action.payload.isFetchRegulationSelection;
        })
        .addCase(toggleFetchRegulationPanel, (state, action) => {
            state.isFetchRegulationPanelOpen = action.payload.isFetchRegulationPanelOpen;
        })
        .addCase(matchingBatchRegulationsReceived, (state, action) => {
            state.matchingBatchRegulations = action.payload;
        })
        .addDefaultCase((state) => state);
});

export default editBatchSelection;
